export default __webpack_public_path__ + "static/media/gallery04.d635cae3.jpg";